
import { MaintenanceAspectTypeInfoBase } from './maintenance-aspect.typeinfo.base';


export class MaintenanceAspectTypeInfo extends MaintenanceAspectTypeInfoBase {
}

export const MAINTENANCE_ASPECT_TYPE: MaintenanceAspectTypeInfo = new MaintenanceAspectTypeInfo();



